module.exports = __webpack_public_path__ + "img/la.9e817279.svg";